module.exports = __webpack_public_path__ + "static/media/porterSq1.827f69ef.jpg";